"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreRole = exports.Player = exports.PlayerFields = exports.PlayerDBFields = exports.playerStatusFields = exports.PlayerStatusEndOption = exports.PlayerStatusChangeSource = exports.PlayerStatusOption = exports.isAssignedDeskInfo = exports.RequestToLeadResponse = exports.MoveDirection = exports.SpriteDirection = void 0;
const events_1 = require("./generated_DO_NOT_TOUCH/events");
Object.defineProperty(exports, "MoveDirection", { enumerable: true, get: function () { return events_1.MoveDirectionEnum_ENUM; } });
Object.defineProperty(exports, "RequestToLeadResponse", { enumerable: true, get: function () { return events_1.RequestToLeadResponseEnum_ENUM; } });
Object.defineProperty(exports, "SpriteDirection", { enumerable: true, get: function () { return events_1.SpriteDirectionEnum_ENUM; } });
function isAssignedDeskInfo(deskInfo) {
    return !!deskInfo?.mapId && !!deskInfo.deskId;
}
exports.isAssignedDeskInfo = isAssignedDeskInfo;
var PlayerStatusOption;
(function (PlayerStatusOption) {
    PlayerStatusOption["Available"] = "Available";
    PlayerStatusOption["Busy"] = "Busy";
    PlayerStatusOption["DoNotDisturb"] = "DoNotDisturb";
})(PlayerStatusOption || (exports.PlayerStatusOption = PlayerStatusOption = {}));
var PlayerStatusChangeSource;
(function (PlayerStatusChangeSource) {
    PlayerStatusChangeSource["Manual"] = "Manual";
    PlayerStatusChangeSource["SleepManager"] = "SleepManager";
})(PlayerStatusChangeSource || (exports.PlayerStatusChangeSource = PlayerStatusChangeSource = {}));
var PlayerStatusEndOption;
(function (PlayerStatusEndOption) {
    PlayerStatusEndOption["NONE_SELECTED"] = "NONE_SELECTED";
    PlayerStatusEndOption["THIRTY_MINUTES"] = "THIRTY_MINUTES";
    PlayerStatusEndOption["ONE_HOUR"] = "ONE_HOUR";
    PlayerStatusEndOption["TWO_HOURS"] = "TWO_HOURS";
    PlayerStatusEndOption["TOMORROW"] = "TOMORROW";
})(PlayerStatusEndOption || (exports.PlayerStatusEndOption = PlayerStatusEndOption = {}));
const PlayerStatusSelect = {
    status: true,
    statusChangeSource: true,
    statusExpiresAt: true,
    statusExpiresToStatus: true,
    statusExpiresToChangeSource: true,
    statusExpiresToExpireTime: true,
};
exports.playerStatusFields = Object.keys(PlayerStatusSelect);
class PlayerDBFields {
    affiliation = "";
    allowScreenPointer = true;
    connected = false;
    currentlyEquippedWearables = undefined;
    description = "";
    deskInfo = {};
    displayEmail = "";
    emojiStatus = "";
    focusModeEndTime = "";
    ambientPlayersMuted = {};
    inventory = { items: {}, order: {} };
    isNpc = false;
    itemString = "";
    map = "";
    name = "";
    personalImageId = "";
    personalImageUrl = "";
    phone = "";
    profileImageId = "";
    profileImageUrl = "";
    pronouns = "";
    textStatus = "";
    timezone = "";
    title = "";
    city = "";
    country = "";
    status = PlayerStatusOption.Available;
    statusUpdatedAt = "";
    statusEndOption = PlayerStatusEndOption.NONE_SELECTED;
    statusChangeSource = PlayerStatusChangeSource.Manual;
    statusExpiresAt = "";
    statusExpiresToStatus = PlayerStatusOption.DoNotDisturb;
    statusExpiresToChangeSource = PlayerStatusChangeSource.SleepManager;
    statusExpiresToExpireTime = "";
    lastRaisedHand = "";
    lastVisited = "";
    handRaisedAt = "";
    startDate = "";
    x = 0;
    y = 0;
    direction = events_1.SpriteDirectionEnum_ENUM.Down;
    spaceUserUuid = "";
    role = CoreRole.Guest;
}
exports.PlayerDBFields = PlayerDBFields;
const PlayerDBSelect = {
    affiliation: true,
    allowScreenPointer: true,
    ambientPlayersMuted: true,
    city: true,
    connected: true,
    country: true,
    currentlyEquippedWearables: true,
    description: true,
    deskInfo: true,
    direction: true,
    displayEmail: true,
    emojiStatus: true,
    focusModeEndTime: true,
    handRaisedAt: true,
    inventory: true,
    isNpc: true,
    itemString: true,
    lastRaisedHand: true,
    map: true,
    name: true,
    personalImageId: true,
    personalImageUrl: true,
    phone: true,
    profileImageId: true,
    profileImageUrl: true,
    pronouns: true,
    startDate: true,
    status: true,
    statusEndOption: true,
    statusUpdatedAt: true,
    statusChangeSource: true,
    statusExpiresAt: true,
    statusExpiresToStatus: true,
    statusExpiresToChangeSource: true,
    statusExpiresToExpireTime: true,
    textStatus: true,
    timezone: true,
    title: true,
    x: true,
    y: true,
    spaceUserUuid: true,
    role: true,
    lastVisited: true,
};
exports.PlayerFields = Object.keys(PlayerDBSelect);
class Player extends PlayerDBFields {
    id;
    userUuid = "";
    spaceUserUuid = "";
    ghost = 0;
    shimmy = false;
    spotlighted = 0;
    emote = undefined;
    away = false;
    activelySpeaking = 0;
    lastActive = "";
    lastInputId = 0;
    whisperId = "";
    isSignedIn = false;
    eventStatus = "";
    inConversation = false;
    vehicleId = "";
    speedModifier = 1;
    isAlone = true;
    isMobile = false;
    followTarget = "";
    manualVideoSrc = "";
    subtitle = "";
    activityStatus = {};
    constructor(id) {
        super();
        this.id = id;
    }
}
exports.Player = Player;
var CoreRole;
(function (CoreRole) {
    CoreRole["Builder"] = "Builder";
    CoreRole["Mod"] = "Mod";
    CoreRole["Owner"] = "Owner";
    CoreRole["GeneralMember"] = "GeneralMember";
    CoreRole["Speaker"] = "Speaker";
    CoreRole["RecordingClient"] = "RecordingClient";
    CoreRole["Guest"] = "Guest";
})(CoreRole || (exports.CoreRole = CoreRole = {}));
//# sourceMappingURL=Player.js.map